import moment, { Moment } from 'moment'

interface Week {
  weekYear: number
  weekNumber: number
  dates: Moment[]
}

export default function calculateWeeksOverlappingADateRange({
  dateStart,
  dateEnd,
}: {
  dateStart?: string | null
  dateEnd?: string | null
}) {
  const start = dateStart ?? dateEnd ?? moment()
  const end = dateEnd ?? dateStart ?? moment()

  const dateStartMoment: Moment = moment(start, 'YYYY-MM-DD')
  const dateEndMoment: Moment = moment(end, 'YYYY-MM-DD')

  const startOfWeek = dateStartMoment.startOf('isoWeek')
  const endOfWeek = dateEndMoment.endOf('isoWeek')

  const datePointer = startOfWeek.clone()

  const weekMap: Record<string, Week> = {}

  while (datePointer.isSameOrBefore(endOfWeek)) {
    const year = datePointer.isoWeekYear()
    const isoWeek = datePointer.isoWeek()
    const key = `${year}-${isoWeek}`

    if (!weekMap[key]) {
      weekMap[key] = {
        weekYear: year,
        weekNumber: isoWeek,
        dates: [],
      }
    }

    weekMap[key].dates.push(datePointer.clone())

    datePointer.add(1, 'days')
  }

  const sortedKeys = Object.keys(weekMap).sort((a, b) => {
    const [yearA, weekA] = a.split('-').map(Number)
    const [yearB, weekB] = b.split('-').map(Number)
    return yearA !== yearB ? yearA - yearB : weekA - weekB
  })

  return sortedKeys.map((key) => weekMap[key])
}
